// Tipos compartidos en toda la app.

export interface EncryptDecipherResponse {
  success: boolean;
  body?: {
    decipherData: string; // JSON string que viene del backend
    createdAt: number;
  };
}

// Datos del cliente que vienen decifrados (de DecipherData parsed).
export interface CustomerData {
  identification?: string;
  name?: string;
  email?: string;
  phone?: string;
  numero_cliente?: string;
  comunicacion_id?: number | string;
  cod_moneda?: 'CRC' | 'USD';
  monto?: number;
  facturas_ids?: string[];
  creditos_ids?: string[];
  encryptId?: string;
}

// Body que recibe POST /payments/bac.
export interface BacPaymentRequest {
  amount: number;
  description?: string;
  personalInfo: {
    name: string;
    phone: string;
    identification: string;
    email?: string;
  };
  paymentMethod: {
    iban: string;
    encryptId?: string;
  };
  metadata: {
    numero_cliente: string;
    comunicacion_id: number | string;
    cod_moneda: 'CRC' | 'USD';
    debitos: string; // JSON string
    creditos: string; // JSON string
  };
}

export interface BacPaymentResponse {
  success: boolean;
  body?: {
    id: string;
    orderId: string;
    status: number;
    authorization: string;
    reference?: string;
    amount: number;
    message?: string;
  };
}

export interface TransactionState {
  code: string;
  message: string;
  payload: string;
}

export interface TransactionRecord {
  id: string;
  orderId: string;
  merchantId: string;
  amount: number;
  status: number; // 0=PENDING, 1=APPROVED, 2=DECLINED, 4=ERROR
  authorization?: string;
  reference?: string;
  processor: string;
  paymentMethod?: any;
  personalInfo?: any;
  metadata?: any;
  states?: TransactionState[];
  lastStatus?: string;
  createdAt: number;
}

export interface TransactionGetResponse {
  success: boolean;
  body?: TransactionRecord[];
}

// Constantes de status que matchean Transaction.STATUS_* del core-backend.
export const TX_STATUS = {
  CHECKOUT_PENDING: 0,
  CHECKOUT_APPROVED: 1,
  CHECKOUT_DECLINED: 2,
  CHECKOUT_CAPTURED: 3,
  CHECKOUT_ERROR: 4,
  CHECKOUT_GENERATED: 5,
  CHECKOUT_CANCELED: 6,
} as const;
